import {gql} from '@apollo/client'

// Admin: set rebilling markups (global, or per-agent with targetUserId).
export const SET_BILLING_MARKUPS = gql`
  mutation SetBillingMarkups($voiceMarkupPct: Float, $rentalMarkup: Float, $targetUserId: ID) {
    setBillingMarkups(voiceMarkupPct: $voiceMarkupPct, rentalMarkup: $rentalMarkup, targetUserId: $targetUserId) {
      success
      markups
    }
  }
`

// Admin: release any owned Twilio number (pool + PolicyDial cleanup, then delete
// on Twilio). Never automatic — the admin confirms each release.
export const RELEASE_TWILIO_NUMBER = gql`
  mutation ReleaseTwilioNumber($phoneNumber: String!) {
    releaseTwilioNumber(phoneNumber: $phoneNumber) {
      success
      warnings
    }
  }
`
